export default {
  AVATAR_1: '/difm/images/avatar-1-279439e8.png',
  AVATAR_2: '/difm/images/avatar-2-4d3b909f.png',
  AVATAR_3: '/difm/images/avatar-3-305937ee.png',
  AVATAR_4: '/difm/images/avatar-4-9f293a74.png',
  AVATAR_5: '/difm/images/avatar-5-818542c5.png',
};
